
import {
  Input,
  Row,
  Col,
  Card,
  Typography,
  Space,
  Button,
  Form,
  Table,
  Popconfirm,
  notification,
} from "antd";
import { DeleteFilled, ExportOutlined, SyncOutlined } from "@ant-design/icons";
import "../Pages/CSS/DonnesBases.css";
import { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import moment from "moment";
import { PrestationsService } from "../Services/PrestationsService";
const { Title } = Typography;
const TypesPrestations = () => {
  const initialTableData = []; // Stocke les données initiales du tableau
  const initialNewPrestation = {
  
    codeprest: "",
    intitule: "",
    compte: "",
  };

  const [tableData, setTableData] = useState(initialTableData);
  const [filteredData, setFilteredData] = useState(initialTableData); // Utilise initialTableData pour initialiser filteredData
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showCreateForm, setShowCreateForm] = useState(true);
  const [newPrestation, setNewPrestation] = useState(initialNewPrestation);

  const prestationsService = new PrestationsService();
  

  useEffect(() => {
    setLoading(true);
    prestationsService
      .getAllPrestation() // Ajoutez les parenthèses pour appeler la fonction
      .then((data) => {
        setTableData(data);
        setLoading(false);
      
      })
      .catch((error) => {
        setLoading(false);
      });
    // eslint-disable-next-line
  }, []);

  const handleUpdate = async () => {
    try {
      if (selectedRowData) {
        await prestationsService.updatePrestation(selectedRowData); // Utilise updatePrestation pour mettre à jour la prestation sélectionnée
        const updatedData = await prestationsService.getAllPrestation();
        setTableData(updatedData);
        setSelectedRowData(null); // Réinitialise les données sélectionnées après la mise à jour
        notification.success({
          message: "Modification réussie",
          description: "La prestation a été modifié avec succès.",
        });
      }
    } catch (error) {
      notification.error({
        message: "erreur",
        description: "Erreur lors de la suppression de la prestation",
      });
    }
  };
  useEffect(() => {
    setFilteredData(tableData); // Initialisation des données filtrées avec les données complètes au chargement
  }, [tableData]);

  const createPrestation = async () => {
    try {
      await prestationsService.addPrestation(newPrestation); // Utilisation de newPrestation pour ajouter la nouvelle prestation
      // Après l'ajout avec succès, rafraîchissez les données
      const updatedData = await prestationsService.getAllPrestation();
      setTableData(updatedData);
      notification.success({
        message: "Ajout réussie",
        description: "La prestation a été ajouté avec succès.",
      });
      setShowCreateForm(false); // Masquer le formulaire après l'ajout
    } catch (error) {
      notification.error({
        message: "erreur",
        description: "Erreur lors de la suppression de la prestation",
      });
    }
  };
  // Ensuite, dans votre fonction handleSave, appelez la fonction createPrestation :
  const handleSave = () => {
    createPrestation();
    // Réinitialiser l'état ou effectuer d'autres actions si nécessaire
  };

  

  const handleDelete = async (compte) => {
    try {
      await prestationsService.deletePrestation(compte);
      const updatedData = await prestationsService.getAllPrestation();
      setTableData(updatedData);
      setSelectedRowData(null);
      notification.success({
        message: "Suppression réussie",
        description: "La prestation a été supprimé avec succès.",
      }); // Notification de suppression réussie
    } catch (error) {
      // Gérer les erreurs avec une notification d'erreur
      notification.error({
        message: "erreur",
        description: "Erreur lors de la suppression de la prestation",
      });
    }
  };

  const handleRowClick = (record) => {
    setSelectedRowData(record); // Mettre à jour les données de la ligne sélectionnée
    setShowCreateForm(false)
  };

  useEffect(() => {
    if (tableData.length > 0) {
      handleNew();
    }
  }, [tableData]);
 
  const handleNew = () => {
    setSelectedRowData(null);
    setShowCreateForm(true);

    const excludeCode = 99;
    const excludeCompte = "602099";

    let dataToConsider = [...tableData]; // Copie de tableData pour éviter de modifier l'original

    let lastCode = 0;
    let lastCompte = 0;

    // Trouver le dernier code et compte avant les exclusions
    for (let i = dataToConsider.length - 1; i >= 0; i--) {
      if (
        parseInt(dataToConsider[i].codespe) !== excludeCode &&
        dataToConsider[i].compte !== excludeCompte
      ) {
        lastCode = parseInt(dataToConsider[i].codeprest);
        lastCompte = parseInt(dataToConsider[i].compte);
        break;
      }
    }

    let nextCode = lastCode + 1;
    while (nextCode === excludeCode) {
      nextCode++;
    }

    const nextCompte = (lastCompte + 1).toString().padStart(6, "0");

    setNewPrestation({
      codeprest: nextCode.toString().padStart(2, "0"),
      intitule: "",
      compte:
        nextCompte !== excludeCompte
          ? nextCompte
          : (parseInt(nextCompte) + 1).toString().padStart(6, "0"),
    });
};


  const handleSearch = (value) => {
    const filtered = tableData.filter((item) =>
      Object.values(item).some(
        (val) =>
          val && val.toString().toLowerCase().includes(value.toLowerCase())
      )
    );

    setFilteredData(filtered); // Met à jour les données filtrées
  };

  const handleResetAll = async () => {
    try {
      const updatedData = await prestationsService.getAllPrestation(); // Récupère les nouvelles données
      setTableData(updatedData); // Met à jour le tableau avec les nouvelles données
      setSelectedRowData(null); // Réinitialise les données sélectionnées
    } catch (error) {}
  };

  const handleExport = () => {
    const exportData = tableData.map((item) => ({
      Code: item.codeprest,
      Libellé: item.intitule,
      Compte: item.compte,
      "Créer le": item.datecreation
        ? moment(item.datecreation).format("DD-MM-YYYY")
        : "", // Formate la date si elle existe
      "Créer par": item.create_by,
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Prestations");

    XLSX.writeFile(workbook, "export_prestations.xlsx");
  };

  const columns = [
    {
      title: "Code",
      dataIndex: "codeprest",
      key: "codeprest",
     
      align:"center",
      ellipsis: true,
  //    width: "15%",
  sorter: (a, b) => {
    const valueA = a.codeprest || "";
    const valueB = b.codeprest || "";
    return valueA.localeCompare(valueB);
  },
      render: (text) => (
        <strong >{text}</strong>
      ),
    },
    {
      title: "Libellé",
      dataIndex: "intitule",
      key: "intitule",
   
      ellipsis: true,
     width: "40%",
     sorter: (a, b) => {
      const valueA = a.intitule || "";
      const valueB = b.intitule || "";
      return valueA.localeCompare(valueB);
    },
    },
    {
      title: "Compte",
      dataIndex: "compte",
      key: "compte",
     
      align: "center",
      ellipsis: true,
     // width: "10%",
     sorter: (a, b) => {
      const valueA = a.compte || "";
      const valueB = b.compte || "";
      return valueA.localeCompare(valueB);
    },
    },
    {
      title: "Créer le",
      dataIndex: "datecreation",
      key: "datecreation",
      ellipsis: true,
      align: "center",
      render: (text) => text ? moment(text).format("DD/MM/YYYY") : "",
      
      sorter: (a, b) => {
        const valueA = new Date(a.datecreation).getTime();
        const valueB = new Date(b.datecreation).getTime();
        return valueA - valueB;
      },
        
      },
   
    {
      title: "Créer par",
      dataIndex: "create_by",
      key: "create_by",
 
      ellipsis: true,
    //  width: "10%",
    sorter: (a, b) => {
      const valueA = a.create_by || "";
      const valueB = b.create_by || "";
      return valueA.localeCompare(valueB);
    },
    },
    {
      title: (
        <div
          style={{
            backgroundColor: " #010f1c",
            color: "white",
            padding: "1px",
          }}
        ></div>
      ),
      key: "action",
    
      align: "center",
    
      ellipsis: true,
    //  width: "5%",
      render: (text, record) => (
        <Popconfirm
          title="Êtes-vous sûr de vouloir supprimer cette prestation ?"
          onConfirm={() => handleDelete(record.compte)}
          okText="Oui"
          cancelText="Non"
        >
          <Button
            danger
            style={{ border: "none", fontSize: "16px" }}
            icon={<DeleteFilled />}
          ></Button>
        </Popconfirm>
      ),
    },
  ];

  return (
    <div>
      <Row gutter={[16, 16]}>
        <Col xs={24} xl={18}>
          <Card>
            <Row gutter={[16, 16]}>
              <Col
                span={9}
                style={{
                  textAlign: "right",
                  display: "flex",
                  justifyContent: "start",
                }}
              >
                {/*  barre de recherche */}
                <Input
                  placeholder="Rechercher..."
                  bordered={false}
                  style={{ borderBottom: "1px solid #ccc" }}
                  onChange={(e) => handleSearch(e.target.value)}
                  onPressEnter={(e) => handleSearch(e.target.value)}
                />
              </Col>
              <Col
                span={15}
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                {/* Vos boutons d'export et d'actualisation */}
                <Space>
                  <Button
                    className="buttonExport"
                    icon={<ExportOutlined />}
                    onClick={handleExport}
                  >
                    Export
                  </Button>
                  <Button className="buttonRefresh" onClick={handleResetAll} icon={<SyncOutlined />}>
                    Actualiser
                  </Button>
                </Space>
              </Col>
            </Row>
          </Card>

          <Table
          style={{ cursor: 'pointer',  whiteSpace: 'nowrap',  width:'100%'}}
          className="custom-header1-table"
            bordered
            showSorterTooltip={false}
            /* size='small' */ columns={columns}
            dataSource={filteredData}
            onRow={(record) => ({
              onClick: () => handleRowClick(record),
            })}
            loading={loading}

          
          />
        </Col>

        <Col xs={24} xl={6}>
          {showCreateForm ? (
            <Card
              size="small"
              className="custom-card"
              title={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Title level={4} style={{ margin: 0,marginLeft: "15px", color: "#ffffff" }}>
                    {" "}
                    Nouvelle Prestations
                  </Title>
                </div>
              }
            >
              <Form layout="vertical">
                <Form.Item label="Code de la prestation">
                  <Input
                  readOnly
                    placeholder="Code de la prestation"
                    value={newPrestation.codeprest}
                    onChange={(e) =>
                      setNewPrestation({
                        ...newPrestation,
                        codeprest: e.target.value,
                      })
                    }
                  />
                </Form.Item>
                <Form.Item label="Libellé de la prestation">
                  <Input
                    placeholder="Libellé de la prestation"
                    value={newPrestation.intitule}
                    onChange={(e) =>
                      setNewPrestation({
                        ...newPrestation,
                        intitule: e.target.value,
                      })
                    }
                  />
                </Form.Item>
                <Form.Item label="Compte de la prestation">
                  <Input
                  readOnly
                    placeholder="Compte de la prestation"
                    value={newPrestation.compte}
                    onChange={(e) =>
                      setNewPrestation({
                        ...newPrestation,
                        compte: e.target.value,
                      })
                    }
                  />
                </Form.Item>
                <Form.Item style={{ textAlign: "right" }}>
                  <Space>
                    <Button
                      onClick={() => setShowCreateForm(false)}
                      style={{ backgroundColor: "#010f1c", color: "white" }}
                    >
                      Annuler
                    </Button>
                    <Button
                      type="primary"
                      onClick={handleSave}
                      style={{ backgroundColor: "#010f1c", color: "white" }}
                    >
                      Enregistrer
                    </Button>
                  </Space>
                </Form.Item>
              </Form>
            </Card>
          ) : (
            <Card
              size="small"
              className="custom-card"
              title={
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Title level={4} style={{ margin: 0, color: "#ffffff" }}>
                    {" "}
                    Modification Prestations
                  </Title>
                </div>
              }
            >
              <Form layout="vertical">
                <Form.Item label="Code de la prestation">
                  <Input
                    placeholder="Code de la prestation"
                    value={selectedRowData ? selectedRowData.codeprest : ""}
                  />
                </Form.Item>
                <Form.Item label="Libellé de la prestation">
                  <Input
                    placeholder="Libellé de la prestation"
                    value={selectedRowData ? selectedRowData.intitule : ""}
                    onChange={(e) =>
                      setSelectedRowData({
                        ...selectedRowData,
                        intitule: e.target.value,
                      })
                    }
                  />
                </Form.Item>
                <Form.Item label="Compte de la prestation">
                  <Input
                    placeholder="Compte de la prestation"
                    value={selectedRowData ? selectedRowData.compte : ""}
                  />
                </Form.Item>
                <Form.Item style={{ textAlign: "right" }}>
                  <Space>
                    <Button
                      type="primary"
                      onClick={handleNew}
                      style={{
                        backgroundColor: "transparent",
                        color: "#010f1c",
                        borderColor: "#010f1c",
                      }}
                    >
                      Nouveau
                    </Button>
                    <Button
                      onClick={handleUpdate}
                      style={{ backgroundColor: "#010f1c", color: "white" }}
                    >
                      Modifier
                    </Button>
                  </Space>
                </Form.Item>
              </Form>
            </Card>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default TypesPrestations;
